import { Card, CardContent, Spinner } from '@crm/ui';
import { ListChecks } from 'lucide-react';
import { useState } from 'react';
import { PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { useOnboarding } from '../api';
import { CategoriesStep } from '../components/categories-step';
import { OnboardingTimeline } from '../components/onboarding-timeline';
import { ServicesStep } from '../components/services-step';

export function OnboardingPage() {
  useDocumentTitle('Assistente de configuracao');

  const progresso = useOnboarding();
  const dados = progresso.data;

  // O mapa de categoria (modelo -> a que o salao acabou de criar) sai do
  // passo de categorias e alimenta o de servicos - e como cada servico sabe
  // em qual categoria de verdade entrar.
  const [categoriaMapa, setCategoriaMapa] = useState<Record<string, string> | null>(null);

  return (
    <div className="space-y-5">
      <PageHeader
        icon={<ListChecks />}
        title="Assistente de configuracao"
        description="O que falta para o salao operar por completo - passo a passo."
      />

      {progresso.isPending || !dados ? (
        <div className="flex justify-center py-20">
          <Spinner />
        </div>
      ) : (
        <Card variant="flush">
          <CardContent className="space-y-5 py-5">
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                {dados.completed} de {dados.total} passos concluidos
              </p>
              <div className="h-2 rounded-full bg-muted">
                <div
                  className="h-2 rounded-full bg-primary"
                  style={{ width: `${Math.round((dados.completed / dados.total) * 100)}%` }}
                />
              </div>
            </div>

            <OnboardingTimeline
              steps={dados.steps}
              customStep={{
                key: 'CATEGORIES',
                render: () => (
                  <CategoriesStep
                    onDone={(mapa) => {
                      setCategoriaMapa(mapa);
                      progresso.refetch();
                    }}
                  />
                ),
              }}
            />

            {/* O passo de servicos so aparece depois do de categorias fechar
                aqui na mesma visita - sem o mapa, nao ha onde encaixar cada
                servico. Reabrindo a pagina depois, o link de sempre serve. */}
            {dados.steps.find((step) => !step.done)?.key === 'SERVICES' && categoriaMapa ? (
              <div className="border-t border-border pt-4">
                <ServicesStep categoriaMapa={categoriaMapa} onDone={() => progresso.refetch()} />
              </div>
            ) : null}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
